// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_eV","advertDetailServiceList__header":"c-o_eW","advertDetailServiceList__list":"c-o_eX"};